export default __webpack_public_path__ + "static/GCCI-UniGraz_Img_c_EUM04_NASA02_USGS91_KLGA02_WEGC04-d95a9d465f14cb451e0d731056e32ca7.png";